<template>
  <v-card color="primary" elevation="20">
    <v-text-field v-model="search" append-icon="search" label=" Search" single-line outline hide-details>
    </v-text-field>
    <v-data-table :headers="headers" :items="equipmentList" :loading="isLoading" :search="search" :pagination.sync="pagination" class="elevation-1">
        <template slot="items" slot-scope="props">
            <td v-if="!underThreshold(props.item.Qty)">{{ props.item.Name }}</td>
            <td style="color:red" v-if="underThreshold(props.item.Qty)">{{ props.item.Name }}</td>
            <td style="text-align:center;" class="text-xs-right">{{ props.item.Qty }}</td>
        </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
    name: 'totalStockTable',
    props: {
        equipmentList: {
            type: Array,
            required: true
        },
        isLoading : {
            type: Boolean,
            required: true
        },
        search: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Equipment",
                    value: "Name"
                },
                {
                    text: "Stock",
                    value: "Qty",
                    align: "right"
                }
            ],
            pagination: {
                sortBy: "Qty"
            },
        }
    },
    methods: {
        underThreshold(qty) {
            if(qty < 10)
                return true
            return false
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/tables/totalStockTable.vue